import { createSHA256 } from "hash-wasm";

export const HASH_CHUNK_SIZE = 8 * 1024 * 1024;

export async function hashBlob(blob, chunkSize) {
  const hasher = await createSHA256();
  hasher.init();

  for (let offset = 0; offset < blob.size; offset += chunkSize) {
    const end = Math.min(offset + chunkSize, blob.size);
    const chunk = new Uint8Array(await blob.slice(offset, end).arrayBuffer());
    hasher.update(chunk);
  }

  return hasher.digest("hex");
}
